module.exports = __webpack_public_path__ + "img/IMG_2248_L_WoodMatted.59b8cce5.jpg";